import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const items = ['2.000 audiolibros de desarrollo personal', '1.500 ebooks de crecimiento personal', 'Bono #1: Curso para optimizar tu dinero', 'Bono #2: Curso de lectura rápida', 'Bono #3: Ebook de gratitud y amor propio', 'Bono #4: Ebook de relaciones personales'];
  const benefits = ['Acceso inmediato', 'Un solo pago', 'Descarga digital', 'Acceso de por vida'];
  return <section id="compra" className="py-12 px-4 bg-black text-white" data-id="element-129">
      <div className="max-w-4xl mx-auto" data-id="element-130">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-131">
          <div className="text-center mb-8" data-id="element-132">
            <div className="inline-block bg-[#8FF650] text-black font-black px-5 py-1.5 rounded-full text-lg mb-4 uppercase tracking-widest animate-pulse" data-id="element-133">
              ⏰ Oferta por tiempo limitado
            </div>
            <h2 className="text-3xl md:text-4xl font-black mb-2" data-id="element-134">
              Accedé hoy a la Biblioteca Completa de Crecimiento Personal
            </h2>
            <p className="text-xl text-[#8FF650] font-bold" data-id="element-135">
              + los 4 bonos incluidos.
            </p>
          </div>

          <div className="bg-gray-900 text-white rounded-2xl p-6 md:p-8 shadow-2xl border-4 border-[#8FF650] max-w-3xl mx-auto" data-id="element-136">
            <h3 className="text-2xl font-black text-center mb-6 border-b border-gray-700 pb-3" data-id="element-137">
              📦 Lo que vas a recibir hoy
            </h3>

            <ul className="space-y-3 mb-8" data-id="element-138">
              {items.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-base md:text-lg font-bold text-gray-200" data-id="element-139">
                  <Check className="w-5 h-5 text-[#8FF650] flex-shrink-0 mt-0.5" data-id="element-140" />
                  <span data-id="element-141">{item}</span>
                </li>)}
            </ul>

            <div className="bg-gray-800 rounded-xl p-6 text-center border border-gray-700 mb-8" data-id="element-142">
              <p className="text-lg text-gray-400 font-bold mb-1" data-id="element-143">
                Valor estimado:{' '}
                <span className="line-through text-red-500/80" data-id="element-144">
                  $59.995 ARS
                </span>
              </p>
              <p className="text-4xl md:text-5xl font-black text-[#8FF650] mb-5" data-id="element-145">
                🔥 HOY SOLO: $18.399 ARS
              </p>

              <div className="flex flex-wrap justify-center gap-3 mb-6" data-id="element-146">
                {benefits.map((benefit, idx) => <span key={idx} className="flex items-center gap-1 text-xs md:text-sm font-bold text-gray-300 bg-gray-900 px-3 py-1 rounded-full border border-gray-700" data-id="element-147">
                    <Check className="w-3 h-3 text-[#8FF650]" data-id="element-148" />
                    {benefit}
                  </span>)}
              </div>

              <CTAButton text="QUIERO ACCEDER A LOS 2000 AUDIOLIBROS AHORA ⚡" className="w-full text-lg md:text-xl py-4" onClick={() => window.open('https://siemprecreciendomas.store/cart/42788575314038:1', '_blank')} data-id="element-149" />
            </div>

            {/* Guarantee */}
            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left bg-[#8FF650]/10 p-5 rounded-xl border border-[#8FF650]/30" data-id="element-150">
              <ShieldCheck className="w-16 h-16 text-[#8FF650] flex-shrink-0" data-id="element-151" />
              <div data-id="element-152">
                <h4 className="text-xl font-black text-[#8FF650] mb-1" data-id="element-153">
                  Garantía sin riesgo
                </h4>
                <p className="text-sm md:text-base font-medium text-gray-300" data-id="element-154">
                  Probá la biblioteca durante 7 días completos. Si sentís que no
                  te aporta valor o no es para vos… te devolvemos el 100% de tu
                  dinero. Sin preguntas.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}